import React, { useState, useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { navLinks } from "../mock";
import { Button } from "./ui/button";
import kitesLogo from "../assets/kites-logo.png";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur-md shadow-sm" : "bg-white/80 backdrop-blur-sm"
      }`}
    >
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 lg:px-10 flex items-center justify-between h-16 md:h-20">
        <Link to="/" className="flex items-center shrink-0">
          <div className="bg-gradient-to-r from-[#416200] to-[#334d00] rounded-xl px-3 py-2 md:px-4 md:py-2.5 shadow-sm">
            <img src={kitesLogo} alt="Kites Fly - The Travel Companion" className="flight-anim h-6 md:h-8 w-auto" />
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-6 lg:gap-10">
          {navLinks.map((l) => (
            <NavLink
              key={l.href}
              to={l.href}
              end={l.href === "/"}
              className={({ isActive }) =>
                `nav-link text-sm lg:text-[15px] font-medium text-slate-700 hover:text-[#70a308] whitespace-nowrap ${
                  isActive ? "active text-[#70a308]" : ""
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:block shrink-0">
          <Link to="/contact">
            <Button className="bg-gradient-to-r from-[#84c009] to-[#4f7700] hover:from-[#70a308] hover:to-[#416200] text-white rounded-full px-4 lg:px-6 h-9 lg:h-11 text-xs lg:text-sm font-semibold shadow-md shadow-[#4f7700]/20">
              Book a Consultation
            </Button>
          </Link>
        </div>

        <button
          className="md:hidden p-2 text-slate-700 shrink-0"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-100 bg-white">
          <div className="px-4 py-4 flex flex-col gap-1">
            {navLinks.map((l) => (
              <NavLink
                key={l.href}
                to={l.href}
                end={l.href === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-3 rounded-lg text-[15px] font-medium ${
                    isActive ? "bg-[#f9fcf3] text-[#5c8606]" : "text-slate-700 hover:bg-slate-50"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/contact" onClick={() => setOpen(false)}>
              <Button className="w-full mt-2 bg-gradient-to-r from-[#84c009] to-[#4f7700] text-white rounded-full h-11 font-semibold">
                Book a Consultation
              </Button>
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
